module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "m-l-50 m-t-0 w-1200"
  }, [_c('el-form', {
    ref: "form",
    attrs: {
      "model": _vm.form,
      "rules": _vm.rules,
      "label-width": "130px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "报销事由",
      "prop": "reason"
    }
  }, [_c('el-input', {
    staticClass: "h-40 w-400",
    attrs: {
      "type": "textarea",
      "placeholder": "请输入报销事由"
    },
    model: {
      value: (_vm.form.reason),
      callback: function($$v) {
        _vm.$set(_vm.form, "reason", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "form.reason"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "备注",
      "prop": "remarks"
    }
  }, [_c('el-input', {
    staticClass: "h-40 w-400",
    attrs: {
      "type": "textarea",
      "placeholder": "请输入备注"
    },
    model: {
      value: (_vm.form.remarks),
      callback: function($$v) {
        _vm.$set(_vm.form, "remarks", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "form.remarks"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "消费事由",
      "prop": "consume_reason"
    }
  }, [_c('el-input', {
    staticClass: "h-40 w-400",
    attrs: {
      "type": "textarea",
      "placeholder": "请输入消费事由"
    },
    model: {
      value: (_vm.form.consume_reason),
      callback: function($$v) {
        _vm.$set(_vm.form, "consume_reason", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "form.consume_reason"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "消费金额",
      "prop": "consume_money"
    }
  }, [_c('el-input', {
    staticClass: "h-40 w-400",
    attrs: {
      "placeholder": "请输入消费金额"
    },
    model: {
      value: (_vm.form.consume_money),
      callback: function($$v) {
        _vm.$set(_vm.form, "consume_money", _vm._n($$v))
      },
      expression: "form.consume_money"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "消费时间",
      "prop": "consume_time"
    }
  }, [_c('el-date-picker', {
    staticClass: "h-40 w-400",
    attrs: {
      "type": "date",
      "placeholder": "选择日期"
    },
    model: {
      value: (_vm.form.consume_time),
      callback: function($$v) {
        _vm.$set(_vm.form, "consume_time", $$v)
      },
      expression: "form.consume_time"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "选择城市",
      "prop": "consume_city"
    }
  }, [_c('el-cascader', {
    staticClass: "w-400",
    attrs: {
      "placeholder": "试试搜索：北京",
      "options": _vm.city_list,
      "filterable": ""
    },
    model: {
      value: (_vm.form.consume_city),
      callback: function($$v) {
        _vm.$set(_vm.form, "consume_city", $$v)
      },
      expression: "form.consume_city"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "票据类型",
      "prop": "cost"
    }
  }, [_c('el-select', {
    staticClass: "h-40 w-400",
    attrs: {
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.form.cost),
      callback: function($$v) {
        _vm.$set(_vm.form, "cost", $$v)
      },
      expression: "form.cost"
    }
  }, _vm._l((_vm.cost_list), function(item) {
    return _c('el-option', {
      key: item.cost_name,
      attrs: {
        "label": item.cost_name,
        "value": item.cost_name
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "发票文件"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "100px",
      "height": "100px",
      "margin-top": "6px"
    },
    attrs: {
      "src": _vm.form.bill_url
    }
  }), _vm._v(" "), _c('el-upload', {
    attrs: {
      "action": _vm.uploadUrl,
      "type": "drag",
      "thumbnail-mode": true,
      "on-preview": _vm.viewPic,
      "on-remove": _vm.handleRemove,
      "on-success": _vm.uploadSuccess,
      "on-error": _vm.uploadFail,
      "default-file-list": _vm.fileList
    }
  }, [_c('i', {
    staticClass: "el-icon-upload"
  }), _vm._v(" "), _c('div', {
    staticClass: "el-dragger__text"
  }, [_vm._v("将文件拖到此处，或"), _c('em', [_vm._v("点击上传")])]), _vm._v(" "), _c('div', {
    staticClass: "el-upload__tip",
    attrs: {
      "slot": "tip"
    },
    slot: "tip"
  }, [_vm._v("只能上传jpg/png文件")])])], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.isLoading,
      "size": "small"
    },
    on: {
      "click": function($event) {
        return _vm.add()
      }
    }
  }, [_vm._v("保 存")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "size": "small"
    },
    on: {
      "click": function($event) {
        return _vm.goback()
      }
    }
  }, [_vm._v("返 回")])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-6fc5d5a9!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Appistrative/company/bill/edit.vue
// module id = 1855
// module chunks = 2